import { render } from "./Copy.vue?vue&type=template&id=1cc24422&scoped=true"
const script = {}

import "./Copy.vue?vue&type=style&index=0&id=1cc24422&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc24422"]])

export default __exports__